import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {DropDownListComponent} from "@syncfusion/ej2-vue-dropdowns";
import {computed} from "vue";

interface Props {
  name?: string
  placeholder?: string,
  modelValue?: string,
  dataSource?: any
  fields?: { text: string, value: string }
  popupWidth?: string
  width?: string

}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*@__PURE__*/_defineComponent({
  __name: 'SogDropDownList',
  props: {
    name: { default: undefined },
    placeholder: { default: undefined },
    modelValue: { default: undefined },
    dataSource: { default: undefined },
    fields: { default: () => {
      return {text: 'value', value: 'id'}
    } },
    popupWidth: { default: undefined },
    width: { default: undefined }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const emit = __emit

const _style = computed<string>(() => (props.width ? "width: " + props.width : ""))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_style.value)
  }, [
    _createVNode(_unref(DropDownListComponent), {
      value: __props.modelValue,
      "float-label-type": "Auto",
      placeholder: __props.placeholder,
      "data-source": __props.dataSource,
      fields: __props.fields,
      name: __props.name,
      "popup-width": __props.popupWidth,
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.value)))
    }, null, 8, ["value", "placeholder", "data-source", "fields", "name", "popup-width"])
  ], 4))
}
}

})